import React from 'react';
import { InputBase, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const CustomSearch = ({ placeholder, onSearch, value }) => {
  
  const handleSearch = (e) => {
    onSearch(e.target.value);
  };

  return (
    <InputBase
      placeholder={placeholder}
      onChange={handleSearch}
      value={value}
      style={{ border: '1px solid #EAEBEE', borderRadius: '20px', width: '280px', backgroundColor:"#fff" }}
      startAdornment={
        <IconButton color="black">
          <SearchIcon style={{ color: 'black' }} />
        </IconButton>
      }
    />
  );
};

export default CustomSearch;
